import React from 'react';
import WarningTriangleIcon from '@shared/icons/WarningTriangleIcon';

const COPY = {
	link_not_found: {
		title: 'This link isn’t valid',
		body: 'Double-check the link from your email, or ask your school to send a new one.',
	},
	link_expired: {
		title: 'This link has expired',
		body: 'For your security, payment links only work for a limited time. Check your email for a newer link, or contact your school to get a fresh one.',
	},
	link_no_longer_valid: {
		title: 'This link is no longer active',
		body: 'The plan or invoice behind this link has changed. Contact your school if you still need to make a change.',
	},
	no_plans: {
		title: 'No active tuition plans',
		body: 'There’s nothing to set up right now. If that seems wrong, contact your school.',
	},
	no_session: {
		title: 'Session expired',
		body: 'Your secure session ended. Re-open this screen from the app or use the link in your email.',
	},
	link_required: {
		title: 'This page needs a secure link',
		body: 'To set up or manage Auto-Pay, open the link in the email from your school, or open this screen from the Perfect Day app.',
	},
};

/** Terminal states: bad/expired links, dead plans, expired webview sessions. */
const DeadLinkScreen = ({ variant = 'link_not_found' }) => {
	const copy = COPY[variant] ?? COPY.link_not_found;

	return (
		<div className="flex flex-col items-center gap-[18px] pt-[12px] text-center">
			<div className="flex h-[72px] w-[72px] items-center justify-center rounded-full bg-[#fef3e2] text-[#16181d]">
				<WarningTriangleIcon width={32} height={32} />
			</div>
			<h1 className="text-[24px] font-extrabold text-[#16181d]">{copy.title}</h1>
			<p className="text-[14px] leading-[21px] text-[#7d7d7d]">{copy.body}</p>
		</div>
	);
};

export default DeadLinkScreen;
